import { render, staticRenderFns } from "./AccessibilityMenu.vue?vue&type=template&id=9ee4fb48&scoped=true"
import script from "./AccessibilityMenu.vue?vue&type=script&lang=js"
export * from "./AccessibilityMenu.vue?vue&type=script&lang=js"
import style0 from "./AccessibilityMenu.vue?vue&type=style&index=0&id=9ee4fb48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ee4fb48",
  null
  
)

export default component.exports